/*
 * @Author: chen hong
 * @Descripttion: vue状态管理 引入同一文件夹(modules)下多个状态管理文件
 * @Date: 2020-01-07 08:47:57
 */

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// 模块的批量导入，类同于import引入同一文件夹下多个文件。
// eslint-disable-next-line no-undef
const modulesFiles = require.context('./modules', true, /\.js$/);
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  modules[moduleName] = value['default'];
  return modules;
}, {});

const store = new Vuex.Store({
  modules,
});

export default store;
